import { render, staticRenderFns } from "./25February.vue?vue&type=template&id=3abe8b4a"
import script from "./25February.vue?vue&type=script&lang=js"
export * from "./25February.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports